import { useState, useEffect, useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import arrow from '../assets/arrow.png'
import strings from '../res/strings'
import TopNavBar from '../components/navigation/TopNavBar'
import SectionHeaderView from '../components/views/SectionHeaderView'
import DatePickerInput from '../components/inputs/DatePickerInput'
import FormInput2 from '../components/inputs/FormInput2'
import RoundedButton from '../components/buttons/RoundedButton'
import RoundedButtonLink from '../components/buttons/RoundedButtonLink'
import RoundedBorderButton from '../components/buttons/RoundedBorderButton'
import LoadingModal from '../components/modals/LoadingModal'
import * as Constants from '../utils/constants'
import dayjs from 'dayjs'
import { UserContext } from '../App'
import { isExpired } from 'react-jwt'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const NewScheduleElectricitySupply = () => {
    const { state } = useLocation()
    let schedule = null
    let fairing = null
    let mooring = null

    if (state) {
        ( { schedule, fairing, mooring } = state)
    }

    const [maxDate, setMaxDate] = useState(null)
    const [excludedDates, setExcludedDates] = useState([])

    const [contractedPower, setContractedPower] = useState('')

    const [date, setDate] = useState(null)
    const [dateError, setDateError] = useState(null)

    const [isLoading, setIsLoading] = useState(true)

    const { loggedUser, setLoggedUser } = useContext(UserContext)
    const navigate = useNavigate()

    useEffect(() => {
        if(loggedUser !== null && loggedUser !== 'refresh') {
            const isTokenExpired = isExpired(loggedUser.jwtToken)

            if(isTokenExpired) {
                setLoggedUser(null)
                navigate('/')
            } else {
                getExcludedDates()

                const today = new Date()
                const oneYearLater = new Date()
                oneYearLater.setFullYear(today.getFullYear() + 1)

                setMaxDate(dayjs(oneYearLater))
            }
        } else if (loggedUser === null) {
            navigate('/')
        }
    }, [loggedUser])

    // Handle get non possible days
    const getExcludedDates = () => {
        fetch(`/api/Schedule/${schedule && schedule.harborId}/NonPossibleDays`, {
            method:'GET',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)
                
                if (response.status === 200) {
                    const jsonRes = await response.json()

                    let noPossibleDates = []

                    jsonRes.map((date) => {
                        noPossibleDates.push(new Date(date))
                    })
                  
                    setExcludedDates(noPossibleDates)
                } else {
                    showErrorToast(strings.getExcludedDatesError)
                    setExcludedDates([])
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)

                setExcludedDates([])
            }, 1000)   
        })
    }

    // Handle changes in date input for electricity supply date
    const onChangeDate = (selectedDate, context) => {
        if(context.validationError !== 'invalidDate' || context.validationError !== 'disablePast') {
            setDate(selectedDate)
        }
    }

    // Handle when date is selected in date input for electricity supply date
    const onAcceptDate = (selectedDate) => {
        setDate(selectedDate)
    }

    // Handle errors in date input for electricity supply date
    const onErrorDate = (error) => {
        if(error) {
            setDateError(strings.invalidDate)
        } else {
            setDateError(null)
        }
    }

    // Handle changes in contracted power input text
    const onChangeContractedPower = (contractedPowerText) => {
        setContractedPower(contractedPowerText.target.value)
    }

    // Handle date formatting
    const formatDate = (date) => {
        const selectedDate = new Date(date)
        selectedDate.setHours(new Date().getHours() + 1)
        return selectedDate.toISOString()
    }

    // Create new schedule and navigate back to Schedules list
    const createSchedule = () => {
        setIsLoading(true)

        let data = null

        if(schedule && fairing) {
            data = {
                UserId: loggedUser.role === Constants.Roles.CLIENT ? loggedUser.userId : schedule.userId,
                BoatId: schedule.boatId,
                HarborId: schedule.harborId,
                ScheduleTypeId: schedule.scheduleTypeId,
                StartDate: fairing.stayStartDate,
                EndDate: fairing.stayEndDate,
                DryStartDate: fairing.dryStartDate,
                SwimStartDate: fairing.swimStartDate,
                LineChangeStartDate: fairing.lineChangeStartDate,
                SupplyPersonnelStartDate: fairing.supplyPersonnelStartDate,
                SupplyPersonnelEndDate: fairing.supplyPersonnelEndDate,
                SupplyPersonnel: fairing.supplyPersonnel,
                RippingStartDate: fairing.rippingStartDate,
                RippingEndDate: fairing.rippingEndDate,
                RippingDescription: fairing.rippingDescription,
                AccessFacilities: [],
                PowerStartDate: formatDate(date),
                PowerEndDate: null,
                Power: contractedPower.length > 0 ? parseInt(contractedPower) : null
            }
        } else if (schedule && mooring) {
            data = {
                UserId: loggedUser.role === Constants.Roles.CLIENT ? loggedUser.userId : schedule.userId,
                BoatId: schedule.boatId,
                HarborId: schedule.harborId,
                ScheduleTypeId: schedule.scheduleTypeId,
                StartDate: mooring.startDate,
                EndDate: mooring.endDate,
                DryStartDate: null,
                SwimStartDate: null,
                LineChangeStartDate: null,
                SupplyPersonnelStartDate: null,
                SupplyPersonnelEndDate: null,
                SupplyPersonnel: null,
                RippingStartDate:null,
                RippingEndDate: null,
                RippingDescription: null,
                AccessFacilities: [],
                PowerStartDate: formatDate(date),
                PowerEndDate: null,
                Power: contractedPower.length > 0 ? parseInt(contractedPower) : null
            }
        } else if (schedule) {
            data = {
                UserId: loggedUser.role === Constants.Roles.CLIENT ? loggedUser.userId : schedule.userId,
                BoatId: schedule.boatId,
                HarborId: schedule.harborId,
                ScheduleTypeId: schedule.scheduleTypeId,
                StartDate: formatDate(date),
                EndDate: null,
                DryStartDate: null,
                SwimStartDate: null,
                LineChangeStartDate: null,
                SupplyPersonnelStartDate: null,
                SupplyPersonnelEndDate: null,
                SupplyPersonnel: null,
                RippingStartDate:null,
                RippingEndDate: null,
                RippingDescription: null,
                AccessFacilities: [],
                PowerStartDate: formatDate(date),
                PowerEndDate: null,
                Power: contractedPower.length > 0 ? parseInt(contractedPower) : null
            }
        }

        // Create new schedule
        fetch('/api/Schedule/Create', {
            method:'POST',
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors',
            body: JSON.stringify(data)
        }).then(async response => {
            setTimeout(() => {
                setIsLoading(false)

                if (response.status === 200) {
                    if(loggedUser && loggedUser.role === Constants.Roles.CLIENT) {
                        navigate('/schedules')
                    } else {
                        navigate('/backoffice-schedules')
                    }
                } else {
                    showErrorToast(strings.createScheduleError)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)
        })
    }

    // Handle show error toast
    const showErrorToast = (error) => {
        toast.error(error, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored'
        })
    }

    return (
        <> 
            <TopNavBar />

            <div className='flex flex-col px-[12.5rem] min-h-screen mb-6'>
                { isLoading ?
                    <LoadingModal />
                :   <>
                        <div className='flex flex-row items-center mt-16 mb-10 space-x-2'>
                            <button onClick={() => navigate(-1)}>
                                <img className='h-5 w-5' src={arrow} alt='Voltar atrás'/>
                            </button>
                            <p className='font-montserrat font-semibold text-accent'>{strings.newSchedule} / {strings.electricitySupply}</p>
                        </div>

                        <SectionHeaderView 
                            text={strings.electricitySupply}
                            margin={24}
                        />

                        <p className='font-montserrat text-sm px-4'>{strings.dateInfo}</p>

                        <div className='flex flex-row space-x-6 px-4 mt-8'>
                            <div className='flex flex-col w-1/2'>
                                <label htmlFor='contractedPower' className='font-montserrat text-sm font-semibold'>{strings.contractedPower}</label>
                                <FormInput2
                                    id='contractedPower' 
                                    type='text'
                                    value={contractedPower}
                                    placeholder={strings.insertContractedPower}
                                    onChange={onChangeContractedPower}
                                    text={strings.kw}
                                />
                            </div>

                            <div className='flex flex-col w-1/2'>
                                <p className='font-montserrat text-sm font-semibold mb-1.5'>{strings.date}</p>
                                <DatePickerInput
                                    minDate={fairing ? dayjs(fairing.stayStartDate) : mooring ? dayjs(mooring.startDate) : dayjs(new Date())}
                                    maxDate={fairing ? dayjs((fairing.stayEndDate)) : mooring ? dayjs(mooring.endDate) : maxDate}
                                    value={date}
                                    onChange={onChangeDate}
                                    onAccept={onAcceptDate}
                                    onError={onErrorDate}
                                    disabledDates={excludedDates}
                                />
                                <p className='font-montserrat text-sm font-medium text-negative mt-1.5 h-2'>{dateError ? dateError : ''}</p>
                            </div>
                        </div>

                        <div className='mt-10 flex flex-row items-center justify-between'>

                            <div className='flex w-60'>
                                <RoundedButtonLink 
                                    path={loggedUser && loggedUser.role === Constants.Roles.CLIENT ? '/schedules': '/backoffice-schedules'}
                                    text={strings.cancel}
                                    height={48}
                                    bgColor='#E85F5C'
                                    flex={true}
                                />
                            </div>
                            
                            <div className='flex flex-row w-[30rem] space-x-6'>
                                <RoundedBorderButton 
                                    text={strings.back}
                                    onClick={() => navigate(-1)}
                                    height={48}
                                    fontWeight='700'
                                />

                                <RoundedButton 
                                    onClick={createSchedule}
                                    text={strings.schedule}
                                    height={48}
                                    bgColor='#007EB4'
                                />
                            </div>

                        </div>
                    </>
                }  
            </div>

            <ToastContainer />
        </>
    )
}

export default NewScheduleElectricitySupply